<template lang="pug">
  .container
    h2.detalle-movimiento DETALLE MOVIMIENTO - {{ numMovimiento }}
    ods-form(:model='data' :disabled="true").form-grid
      ods-form-item(label="ESTADO" prop="desestadoqr")
        ods-input(v-model="data.desestadoqr")
      ods-form-item(label="IMPORTE" prop="importe")
        ods-input(v-model="data.importe")
      ods-form-item(label="MOTIVO RECHAZO" prop="desrechazoqr")
        ods-input(v-model="data.desrechazoqr")
      ods-form-item(label="MONEDA" prop="clamoniso")
        ods-input(v-model="data.clamoniso")
      ods-form-item(label="TARJETA" prop="idpan")
        ods-input(v-model="data.idpan")
      ods-form-item(label="DOCUMENTO" prop="numdoc_com")
        ods-input(v-model="data.numdoc_com")
      ods-form-item(label="COMERCIO" prop="nomcomred")
        ods-input(v-model="data.nomcomred")
      ods-form-item(label="TEXTO DE LA OPERACIÓN" prop="texto")
        ods-input(v-model="data.texto")
      ods-form-item(label="TERMINAL" prop="destpv")
        ods-input(v-model="data.destpv")
      ods-form-item(label="TIPO OPERACIÓN QR" prop="destipoperqr")
        ods-input(v-model="data.destipoperqr")
      ods-form-item(label="FECHA" prop="fecha")
        ods-input(v-model="data.fecha")
      ods-form-item(label="TELÉFONO" prop="telefono_com")
        ods-input(v-model="data.telefono_com")

</template>

<script>
export default {
  props: {
    data: {
      required: true
    }
  },

  data () {
    return {
      type: 'textarea',
      rowsData: '4',
      movimiento: '',
      numMovimiento: ''
    }
  }
}
</script>

<style type="scss" scoped>
  .table-center {
    display: flex;
    align-items:center;
  }
  .detalle-movimiento {
    color: #060E14;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;
  }
  .rectangle {
    height: 700px;
    width: 710px;
    background-color: #FFFFFF;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.1);
    margin-left: auto;
    margin-right: auto;
    border-radius: 0;
  }
  .terminales-table {
    margin: rem(20) rem(25) rem(25) rem(25);
  }
  .movimientos-table {
    margin: rem(20) rem(25) rem(25) rem(25);
  }
  .usuarios-table {
    margin: rem(20) rem(25) rem(25) rem(25);
  }
  /deep/ .ods-tabs__nav-scroll {
    background-color: #FFFFFF;
    padding: 10px 20px 20px 30px;
  }
  /deep/ .ods-module__body {
    padding: 0 15px 5px;
}
.form-grid {
  margin-top: rem(24);
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  column-gap: 48px;
}
</style>
